import './ExploreContainer.css';

interface ContainerProps { }

const ExploreContainer: React.FC<ContainerProps> = () => {
  return (
    <div className="container">
      <strong>You are @ PetShelter Website</strong>
    </div>
  );
};

export default ExploreContainer;
